import { useUpsellModalQueryState } from '../../hooks/useUpsellModalQueryState'
import { ExperimentModal } from './experiment-modal/experiment-modal'
import { RecurlyModalContainer } from './recurly-modal/recurly-modal-container'

export const UpsellModal = () => {
  const { experiment } = useUpsellModalQueryState()

  if (experiment && experiment.variant && experiment.images && experiment.images.length) {
    return <ExperimentModal />
  }

  return <RecurlyModalContainer />
}
